module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "GLOSSARY"
    }
  }, [_c('header', [_c('p', {
    staticClass: "h2f",
    attrs: {
      "id": "bk4glo"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_320",
      "title": "320"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_321",
      "title": "321"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rbk4glo"
    }
  }, [_vm._v("GLOSSARY")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("ab im kopp")]), _vm._v("—crazy, crazy in the head")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("daag/daags")]), _vm._v("—day/days")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("daed")]), _vm._v("—dad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("danki")]), _vm._v("—thank you")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("dawdi haus")]), _vm._v("—small house used for in-laws/parents/grandparents")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("familye")]), _vm._v("—family")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("geh")]), _vm._v("—go")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("grossdaadi")]), _vm._v("—grandfather")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("gut")]), _vm._v("—good")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("gute nacht")]), _vm._v("—good night")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("haus")]), _vm._v("—house")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("kaffee")]), _vm._v("—coffee")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("kapp")]), _vm._v("—white hat worn by Amish women")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("maed")]), _vm._v("—girls")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("mamm")]), _vm._v("—mom")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("mei")]), _vm._v("—my")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("nee")]), _vm._v("—no")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("sehr")]), _vm._v("—very")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("sohn")]), _vm._v("—son")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("ya")]), _vm._v("—yes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("yer")]), _vm._v("—your")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("yers")]), _vm._v("—yours")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("yerself")]), _vm._v("—yourself")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc6c946e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780718023676_Book_4glo.vue
// module id = 69
// module chunks = 0